import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StarRating from '../Review/Questions/StarRating';
import TextAreaInput from '../common/TextAreaInput';
import { postRequest } from '../../requestUtils';
import './ConsultantReview.scss';
var instantiateRatings = function instantiateRatings(categories) {
  return categories.map(function (category) {
    return {
      id: null,
      score: null,
      rating_category_id: category.id
    };
  });
};
var ratingsCount = function ratingsCount(ratings) {
  return ratings.filter(function (r) {
    return r.score;
  }).length;
};
var getAverageScore = function getAverageScore(ratings) {
  if (ratingsCount(ratings) === 0) return 0;
  var ratingSum = ratings.reduce(function (prev, curr) {
    return prev + curr.score;
  }, 0);
  return (ratingSum / ratingsCount(ratings)).toFixed(1);
};
var ConsultantReview = /*#__PURE__*/function (_Component) {
  function ConsultantReview(props) {
    var _this;
    _classCallCheck(this, ConsultantReview);
    _this = _callSuper(this, ConsultantReview, [props]);
    _this.state = {
      ratings: instantiateRatings(props.ratingCategories),
      reviewText: ''
    };
    _this.handleReviewSave = _this.handleReviewSave.bind(_this);
    _this.handleUserInput = _this.handleUserInput.bind(_this);
    _this.renderActionButton = _this.renderActionButton.bind(_this);
    _this.handleAPISync = _this.handleAPISync.bind(_this);
    _this.handleUpdateReview = _this.handleUpdateReview.bind(_this);
    return _this;
  }
  _inherits(ConsultantReview, _Component);
  return _createClass(ConsultantReview, [{
    key: "saveEnabled",
    value: function saveEnabled() {
      var _this$state = this.state,
        ratings = _this$state.ratings,
        reviewText = _this$state.reviewText;
      return ratingsCount(ratings) > 0 && reviewText;
    }
  }, {
    key: "handleAPISync",
    value: function handleAPISync(path, params, token, fxn) {
      var afterSubmitPath = this.props.afterSubmitPath;
      fxn(path, params, token).then(function () {
        window.location.href = afterSubmitPath;
      });
    }
  }, {
    key: "handleReviewSave",
    value: function handleReviewSave() {
      var _this$state2 = this.state,
        ratings = _this$state2.ratings,
        reviewText = _this$state2.reviewText;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        consultantId = _this$props.consultantId,
        includeProjectParam = _this$props.includeProjectParam,
        projectId = _this$props.projectId;
      var saveReview = {
        reviewee_id: consultantId,
        recommend: true,
        private_review: reviewText,
        review_ratings_attributes: ratings.map(function (rating) {
          return {
            id: rating.id,
            rating_category_id: rating.rating_category_id,
            score: rating.score
          };
        })
      };
      if (includeProjectParam) {
        Object.assign(saveReview, {
          project_id: projectId
        });
      }
      this.handleAPISync('/consultant_reviews', {
        review: saveReview
      }, csrfToken, postRequest);
    }
  }, {
    key: "handleUserInput",
    value: function handleUserInput(type, value, id) {
      var ratings = this.state.ratings;
      if (type === 'ratings') {
        ratings.find(function (r) {
          return r.rating_category_id === id;
        }).score = value;
        this.setState(_defineProperty({}, type, ratings));
      } else {
        this.setState(_defineProperty({}, type, value));
      }
    }
  }, {
    key: "handleUpdateReview",
    value: function handleUpdateReview(value) {
      this.setState({
        reviewText: value
      });
    }
  }, {
    key: "renderActionButton",
    value: function renderActionButton() {
      return /*#__PURE__*/React.createElement("button", {
        id: "review-save-feedback",
        className: "btn btn-primary bigger-button full-width btn-review",
        onClick: this.handleReviewSave,
        disabled: !this.saveEnabled()
      }, "Save Feedback");
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state3 = this.state,
        ratings = _this$state3.ratings,
        reviewText = _this$state3.reviewText;
      var _this$props2 = this.props,
        consultantName = _this$props2.consultantName,
        ratingCategories = _this$props2.ratingCategories;
      return /*#__PURE__*/React.createElement("div", {
        className: "reviews-container style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "reviews-header g-row g-row-justify-right"
      }), /*#__PURE__*/React.createElement("h2", {
        className: "reviews-intro normal-weight"
      }, "Leave internal feedback about", ' ', /*#__PURE__*/React.createElement("strong", null, consultantName)), /*#__PURE__*/React.createElement("div", {
        className: "mt-2 body-text-2 muted-gray-text"
      }, "This is only visible to Clora internally. Consultants and Employers cannot see this."), /*#__PURE__*/React.createElement("div", {
        className: "reviews-question rating"
      }, /*#__PURE__*/React.createElement("p", {
        className: "mb-2"
      }, "1. Rate", ' ', /*#__PURE__*/React.createElement("strong", null, consultantName), /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, "*")), /*#__PURE__*/React.createElement("div", {
        className: "mb-3 body-text-2 muted-gray-text"
      }, "Indicate any applicable category."), /*#__PURE__*/React.createElement("div", {
        className: "ml-30"
      }, ratingCategories.map(function (_ref, idx) {
        var id = _ref.id,
          name = _ref.name;
        return /*#__PURE__*/React.createElement(StarRating, {
          id: id,
          name: name,
          edit: true,
          handleUserInput: _this2.handleUserInput,
          rating: ratings[idx].score ? ratings[idx] : null
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "star-total demibold"
      }, "Total Score:", getAverageScore(ratings)))), /*#__PURE__*/React.createElement("div", {
        className: "reviews-question recommendation"
      }, /*#__PURE__*/React.createElement("p", {
        className: "body-text-1 mb-3"
      }, "2. Leave comment", /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, "*")), /*#__PURE__*/React.createElement(TextAreaInput, {
        className: "form-control fs-hide",
        placeholder: "Type your review here...",
        textAreaPrompt: "",
        rows: 3,
        onAnswerChange: this.handleUpdateReview,
        value: reviewText
      })), /*#__PURE__*/React.createElement("div", {
        className: "reviews-footer"
      }, this.renderActionButton()));
    }
  }]);
}(Component);
export { ConsultantReview as default };
ConsultantReview.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  consultantName: PropTypes.string.isRequired,
  consultantId: PropTypes.number.isRequired,
  ratingCategories: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  afterSubmitPath: PropTypes.string.isRequired,
  projectId: PropTypes.number.isRequired,
  includeProjectParam: PropTypes.bool
};
ConsultantReview.defaultProps = {
  includeProjectParam: false
};